module.exports = __webpack_public_path__ + "static/media/PerakendeTV.bfd6865b.png";